module.exports = __webpack_public_path__ + "static/img/part3.0b3143d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/part3.png
// module id = oBvE
// module chunks = 96